import styled, { css } from 'styled-components'

import { space, SpaceProps } from '../../themes'

const createTruncateLinesCss = (lines = 1) => {
  return lines
    ? css`
        // Fallback for browsers that don't support line-clamp
        overflow: hidden;
        text-overflow: ellipsis;

        ${lines === 1 &&
        css`
          white-space: nowrap;
        `}

        ${lines > 1 &&
        css`
          @supports (-webkit-line-clamp: ${lines}) {
            display: -webkit-box;
            -webkit-line-clamp: ${lines};
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        `}
      `
    : ''
}

export const BaseTruncate = styled.span<SpaceProps & { lines: number }>`
  ${space}
  display: block;

  ${({ lines }) => createTruncateLinesCss(lines)}
`
